import React from 'react';
import { BrowserRouter as Router, Switch, Link } from 'react-router-dom';
import AppRoute from './AppRoute';

export default function App() {
  return (
    <Router>
      <div>
        <nav>
          <ul>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/about">About</Link>
            </li>
            <li>
              <Link to="/users">Users</Link>
            </li>
            <li>
              <Link to="/abcde-burger">Restaurant</Link>
            </li>
          </ul>
        </nav>

        <Switch>
          <AppRoute path="/users" desktop mobile component="Users" />
          <AppRoute path="/about" desktop component="About" />
          <AppRoute path="/:slug" service />
        </Switch>
      </div>
    </Router>
  );
}
